import KDKForm from './kdk-form';

require('./styles.scss');

export { KDKForm };

export default KDKForm;
